<template>
	<div class="px-8 pt-4 flex no-bottom-margin">
		<div class="flex flex-wrap w-full">
			<BaseSelect
				:label="$t('status')"
				@input="directSearch"
				:options="statusOptions"
				v-model="status"
				:filter-only="true"
				class="md:w-1/3 pr-0 md:pr-4 searchline-multiselect"
				v-if="showCol([2, 3, 7, 8])"
			/>
			<BaseSelect
				:label="$t('transmitter')"
				@input="directSearch"
				:options="mediatedCompanies"
				v-model="selectedMediatedCompany"
				:filter-only="true"
				class="md:w-1/4 pr-0 md:pr-4 searchline-multiselect"
				:allow-empty="true"
				v-if="showCol([4])"
			/>
			<BaseDatepicker
				@input="search"
				:label="$t('period')"
				v-model="dateRange"
				mode="range"
				:show-remove="true"
				:columns="2"
				:rows="2"
				:filter-only="true"
				class="md:w-1/4 pr-0 md:pr-4 searchline-datepicker"
				v-if="showCol([1, 2, 3, 4, 7])"
			/>
			<BaseInput
				ref="searchField"
				v-model="searchValue"
				:label="$t('search_term')"
				class="mr-4 flex-grow"
				@input="search"
				:filter-only="true"
				mask="UUUUUUUUUUUUUUUUUUUUUU"
				:placeholder="searchValuePlaceholder"
			/>
		</div>
		<div>
			<BaseButton @click="search" class="mt-8 searchline-button btn-blue">
				{{ $t('search') }}
				<font-awesome-icon :icon="['fas', 'spinner']" spin v-if="isSearchRunning" />
			</BaseButton>
		</div>
	</div>
</template>

<script>
import BaseButton from '@/components/forms/buttons/BaseButton';
import BaseDatepicker from '@/components/forms/inputs/BaseDatepicker';
import BaseSelect from '@/components/forms/inputs/BaseSelect';
import BaseInput from '@/components/forms/inputs/BaseInput';
import { getUnixTimestamp } from '@/plugins/Utils';
import Authentication from '@/mixins/Authentication';

export default {
	name: 'OverviewSearch',
	components: { BaseInput, BaseSelect, BaseDatepicker, BaseButton },
	mixins: [Authentication],
	props: {
		searchValuePlaceholder: {
			default: function() {
				return this.$t('search_term');
			},
		},
		isForPayment: { default: false },
		value: {
			type: String,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		isSearchRunning: {
			type: Boolean,
		},
		showCol: {},
	},
	data() {
		const d = new Date();
		this.year = d.getFullYear();

		return {
			selectedMediatedCompany: null,
			searchValue: null,
			dateRange: null,
			year: null,
			status: { display: this.$t('open_processes'), value: 'opened' },
			yearOptions: this.getYearOptions(),
			license_plate: null,
			damageAssessorReferenceNumber: null,
			lawyerOfficeReferenceNumber: null,
			repairShopReferenceNumber: null,
			imd_net: null,
			customer: null,
		};
	},
	mounted() {
		if (this.$route.query.searchValue) {
			this.searchValue = this.$route.query.searchValue;
			this.directSearch();
		}
		this.$refs.searchField.focus();
	},
	computed: {
		statusOptions() {
			return [
				{ display: this.$t('open_processes'), value: 'opened' },
				{ display: this.$t('all_processes'), value: 'all' },
				!this.showCol([3])
					? {
							display:
								this.isUserAllowedInLevel2 && !this.isAuthenticatedUserInGroupAdmin
									? this.$t('own_processes')
									: this.$t('own_and_not_assigned_processes'),
							value: 'own',
					  }
					: null,
				this.isForPayment ? { display: this.$t('overpaid_processes'), value: 'overpayed' } : null,
				{ display: this.$t('closed_processes'), value: 'closed' },
			].filter(option => option);
		},
		mediatedCompanies() {
			return this.$store.getters.getUser.person?.company?.mediatedCompanies?.map(company => {
				return {
					display: company.name,
					value: company.name,
				};
			});
		},
	},
	methods: {
		search() {
			this.$emit('search', this.getData());
		},
		directSearch() {
			this.$emit('directSearch', this.getData());
		},
		getData() {
			this.searchValue = this.searchValue?.trim();
			// if (this.searchValue) {
			// 	this.$router.replace({ name: this.$route.name, query: { searchValue: this.searchValue } });
			// } else {
			// 	this.$router.replace({ name: this.$route.name });
			// }

			let dateRangeStr = '';
			if (this.dateRange) {
				this.dateRange.start.setHours(0, 0, 0, 0);
				this.dateRange.end.setHours(23, 59, 59, 0);
				dateRangeStr += getUnixTimestamp(this.dateRange.start) + '-' + getUnixTimestamp(this.dateRange.end);
			}

			return {
				status: this.status ? this.status.value : null,
				range: this.dateRange ? dateRangeStr : null,
				vehicles: this.searchValue,
				damageAssessorReferenceNumber: this.searchValue,
				lawyerOfficeReferenceNumber: this.searchValue,
				repairShopReferenceNumber: this.searchValue,
				imd_net: this.searchValue,
				customer: this.searchValue,
				repairshop: this.selectedMediatedCompany?.value,
			};
		},
		getYearOptions() {
			const returnArr = [];
			let year = new Date();
			year = year.getFullYear();

			for (let i = year - 4; i <= year; i++) {
				returnArr.push({ display: i, value: i });
			}

			return returnArr;
		},
	},
};
</script>

<style></style>
